import SessionKeystore from 'session-keystore';

const keystore = new SessionKeystore();

export default keystore;
